import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  height: "24px",
  width: "24px",
  id: "export",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.012 30.509",
  style: {"fill":"currentColor"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "Tracé_86",
      "data-name": "Tracé 86",
      d: "M14.214,22.665,0,16.15v3.037a.644.644,0,0,0,.389.592L14.214,25.79Z",
      transform: "translate(0 4.718)"
    }, null, -1),
    _createElementVNode("path", {
      id: "Tracé_87",
      "data-name": "Tracé 87",
      d: "M13,22.665v3.126L26.825,19.78a.647.647,0,0,0,.389-.593V16.15Z",
      transform: "translate(3.798 4.718)"
    }, null, -1),
    _createElementVNode("path", {
      id: "Tracé_88",
      "data-name": "Tracé 88",
      d: "M15.368,18.09h-3.23a1.617,1.617,0,0,1-1.615-1.615V8.722H6.969a.97.97,0,0,1-.685-1.654L13.068.284a.969.969,0,0,1,1.371,0l6.784,6.784a.97.97,0,0,1-.685,1.654H16.983v7.753A1.617,1.617,0,0,1,15.368,18.09Z",
      transform: "translate(1.753 0)"
    }, null, -1),
    _createElementVNode("path", {
      id: "Tracé_89",
      "data-name": "Tracé 89",
      d: "M21.321,11.063v2.18a4.2,4.2,0,0,1-4.2,4.2h-3.23a4.2,4.2,0,0,1-4.2-4.2v-2.18L0,15.5l15.506,7.107L31.012,15.5Z",
      transform: "translate(0 3.232)"
    }, null, -1)
  ])))
}